// src/Eu.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Eu_default = createIcon({
  displayName: "Eu",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsxs("mask", {
        id: "path-1-outside-1_7559_113489",
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "50",
        height: "34",
        fill: "black",
        children: [
          /* @__PURE__ */ jsx("rect", {
            fill: "white",
            width: "50",
            height: "34"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M1 1H49V33H1V1Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M23.6144 10.2641L24.9999 9.3L26.3854 10.2641L25.8966 8.6485L27.2417 7.62875L25.5541 7.59436L24.9999 6L24.4457 7.59436L22.7581 7.62875L24.1032 8.6485L23.6144 10.2641Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M27.168 10.4738L28.8499 10.3316L29.5677 11.8593L29.9522 10.2157L31.627 10.0051L30.1827 9.13157L30.4999 7.47372L29.2228 8.57737L27.7441 7.76337L28.3991 9.31903L27.168 10.4738Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M31.6683 13.15L30.1406 12.4322L31.7842 12.0477L31.9948 10.3729L32.8683 11.8172L34.5262 11.5L33.4225 12.7771L34.2365 14.2558L32.6809 13.6008L31.5261 14.8319L31.6683 13.15Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M31.7358 15.6145L32.6999 17L31.7358 18.3855L33.3514 17.8967L34.3712 19.2418L34.4055 17.5542L35.9999 17L34.4055 16.4458L34.3712 14.7582L33.3514 16.1033L31.7358 15.6145Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M31.6683 20.85L31.5261 19.1681L32.6809 20.3992L34.2365 19.7442L33.4225 21.2229L34.5262 22.5L32.8683 22.1828L31.9948 23.6271L31.7842 21.9523L30.1406 21.5678L31.6683 20.85Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M29.5677 22.1407L28.8499 23.6684L27.168 23.5262L28.3991 24.681L27.7441 26.2366L29.2228 25.4226L30.4999 26.5263L30.1827 24.8684L31.627 23.9949L29.9522 23.7843L29.5677 22.1407Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M24.9999 24.7L26.3854 23.7359L25.8966 25.3515L27.2417 26.3713L25.5541 26.4056L24.9999 28L24.4457 26.4056L22.7581 26.3713L24.1032 25.3515L23.6144 23.7359L24.9999 24.7Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M22.8318 23.5262L21.1499 23.6684L20.4321 22.1407L20.0476 23.7843L18.3728 23.9949L19.8171 24.8684L19.4999 26.5263L20.777 25.4226L22.2557 26.2366L21.6007 24.681L22.8318 23.5262Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M18.3315 20.85L19.8592 21.5678L18.2156 21.9523L18.005 23.6271L17.1315 22.1828L15.4736 22.5L16.5773 21.2229L15.7633 19.7442L17.3189 20.3992L18.4737 19.1681L18.3315 20.85Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M18.264 18.3855L17.2999 17L18.264 15.6145L16.6484 16.1033L15.6286 14.7582L15.5943 16.4458L13.9999 17L15.5943 17.5542L15.6286 19.2418L16.6484 17.8967L18.264 18.3855Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M18.3315 13.15L18.4737 14.8319L17.3189 13.6008L15.7633 14.2558L16.5773 12.7771L15.4736 11.5L17.1315 11.8172L18.005 10.3729L18.2156 12.0477L19.8592 12.4322L18.3315 13.15Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M20.4321 11.8593L21.1499 10.3316L22.8318 10.4738L21.6007 9.31903L22.2557 7.76337L20.777 8.57737L19.4999 7.47372L19.8171 9.13157L18.3728 10.0051L20.0476 10.2157L20.4321 11.8593Z"
          })
        ]
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M1 1H49V33H1V1Z",
        fill: "#0D3073"
      }),
      /* @__PURE__ */ jsxs("g", {
        fill: "#FBB43A",
        children: [
          /* @__PURE__ */ jsx("path", {
            d: "M23.6144 10.2641L24.9999 9.3L26.3854 10.2641L25.8966 8.6485L27.2417 7.62875L25.5541 7.59436L24.9999 6L24.4457 7.59436L22.7581 7.62875L24.1032 8.6485L23.6144 10.2641Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M27.168 10.4738L28.8499 10.3316L29.5677 11.8593L29.9522 10.2157L31.627 10.0051L30.1827 9.13157L30.4999 7.47372L29.2228 8.57737L27.7441 7.76337L28.3991 9.31903L27.168 10.4738Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M31.6683 13.15L30.1406 12.4322L31.7842 12.0477L31.9948 10.3729L32.8683 11.8172L34.5262 11.5L33.4225 12.7771L34.2365 14.2558L32.6809 13.6008L31.5261 14.8319L31.6683 13.15Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M31.7358 15.6145L32.6999 17L31.7358 18.3855L33.3514 17.8967L34.3712 19.2418L34.4055 17.5542L35.9999 17L34.4055 16.4458L34.3712 14.7582L33.3514 16.1033L31.7358 15.6145Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M31.6683 20.85L31.5261 19.1681L32.6809 20.3992L34.2365 19.7442L33.4225 21.2229L34.5262 22.5L32.8683 22.1828L31.9948 23.6271L31.7842 21.9523L30.1406 21.5678L31.6683 20.85Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M29.5677 22.1407L28.8499 23.6684L27.168 23.5262L28.3991 24.681L27.7441 26.2366L29.2228 25.4226L30.4999 26.5263L30.1827 24.8684L31.627 23.9949L29.9522 23.7843L29.5677 22.1407Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M24.9999 24.7L26.3854 23.7359L25.8966 25.3515L27.2417 26.3713L25.5541 26.4056L24.9999 28L24.4457 26.4056L22.7581 26.3713L24.1032 25.3515L23.6144 23.7359L24.9999 24.7Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M22.8318 23.5262L21.1499 23.6684L20.4321 22.1407L20.0476 23.7843L18.3728 23.9949L19.8171 24.8684L19.4999 26.5263L20.777 25.4226L22.2557 26.2366L21.6007 24.681L22.8318 23.5262Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M18.3315 20.85L19.8592 21.5678L18.2156 21.9523L18.005 23.6271L17.1315 22.1828L15.4736 22.5L16.5773 21.2229L15.7633 19.7442L17.3189 20.3992L18.4737 19.1681L18.3315 20.85Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M18.264 18.3855L17.2999 17L18.264 15.6145L16.6484 16.1033L15.6286 14.7582L15.5943 16.4458L13.9999 17L15.5943 17.5542L15.6286 19.2418L16.6484 17.8967L18.264 18.3855Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M18.3315 13.15L18.4737 14.8319L17.3189 13.6008L15.7633 14.2558L16.5773 12.7771L15.4736 11.5L17.1315 11.8172L18.005 10.3729L18.2156 12.0477L19.8592 12.4322L18.3315 13.15Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M20.4321 11.8593L21.1499 10.3316L22.8318 10.4738L21.6007 9.31903L22.2557 7.76337L20.777 8.57737L19.4999 7.47372L19.8171 9.13157L18.3728 10.0051L20.0476 10.2157L20.4321 11.8593Z"
          })
        ]
      }),
      /* @__PURE__ */ jsxs("g", {
        fill: "#FBB43A",
        stroke: "#F3F6F9",
        strokeWidth: "2",
        mask: "url(#path-1-outside-1_7559_113489)",
        children: [
          /* @__PURE__ */ jsx("path", {
            d: "M1 1H49V33H1V1Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M23.6144 10.2641L24.9999 9.3L26.3854 10.2641L25.8966 8.6485L27.2417 7.62875L25.5541 7.59436L24.9999 6L24.4457 7.59436L22.7581 7.62875L24.1032 8.6485L23.6144 10.2641Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M27.168 10.4738L28.8499 10.3316L29.5677 11.8593L29.9522 10.2157L31.627 10.0051L30.1827 9.13157L30.4999 7.47372L29.2228 8.57737L27.7441 7.76337L28.3991 9.31903L27.168 10.4738Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M31.6683 13.15L30.1406 12.4322L31.7842 12.0477L31.9948 10.3729L32.8683 11.8172L34.5262 11.5L33.4225 12.7771L34.2365 14.2558L32.6809 13.6008L31.5261 14.8319L31.6683 13.15Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M31.7358 15.6145L32.6999 17L31.7358 18.3855L33.3514 17.8967L34.3712 19.2418L34.4055 17.5542L35.9999 17L34.4055 16.4458L34.3712 14.7582L33.3514 16.1033L31.7358 15.6145Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M31.6683 20.85L31.5261 19.1681L32.6809 20.3992L34.2365 19.7442L33.4225 21.2229L34.5262 22.5L32.8683 22.1828L31.9948 23.6271L31.7842 21.9523L30.1406 21.5678L31.6683 20.85Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M29.5677 22.1407L28.8499 23.6684L27.168 23.5262L28.3991 24.681L27.7441 26.2366L29.2228 25.4226L30.4999 26.5263L30.1827 24.8684L31.627 23.9949L29.9522 23.7843L29.5677 22.1407Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M24.9999 24.7L26.3854 23.7359L25.8966 25.3515L27.2417 26.3713L25.5541 26.4056L24.9999 28L24.4457 26.4056L22.7581 26.3713L24.1032 25.3515L23.6144 23.7359L24.9999 24.7Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M22.8318 23.5262L21.1499 23.6684L20.4321 22.1407L20.0476 23.7843L18.3728 23.9949L19.8171 24.8684L19.4999 26.5263L20.777 25.4226L22.2557 26.2366L21.6007 24.681L22.8318 23.5262Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M18.3315 20.85L19.8592 21.5678L18.2156 21.9523L18.005 23.6271L17.1315 22.1828L15.4736 22.5L16.5773 21.2229L15.7633 19.7442L17.3189 20.3992L18.4737 19.1681L18.3315 20.85Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M18.264 18.3855L17.2999 17L18.264 15.6145L16.6484 16.1033L15.6286 14.7582L15.5943 16.4458L13.9999 17L15.5943 17.5542L15.6286 19.2418L16.6484 17.8967L18.264 18.3855Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M18.3315 13.15L18.4737 14.8319L17.3189 13.6008L15.7633 14.2558L16.5773 12.7771L15.4736 11.5L17.1315 11.8172L18.005 10.3729L18.2156 12.0477L19.8592 12.4322L18.3315 13.15Z"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M20.4321 11.8593L21.1499 10.3316L22.8318 10.4738L21.6007 9.31903L22.2557 7.76337L20.777 8.57737L19.4999 7.47372L19.8171 9.13157L18.3728 10.0051L20.0476 10.2157L20.4321 11.8593Z"
          })
        ]
      })
    ]
  })
});

export {
  Eu_default
};
